import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class ProductVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductCreateany,
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationProductTaskCreate,
        PermissionAttributesEnum.ContextOperationProductReservationCreate,
      ],
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductReadany,
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationProductTaskRead,
        PermissionAttributesEnum.ContextOperationProductReservationRead,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductDeleteany,
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationProductTaskDelete,
        PermissionAttributesEnum.ContextOperationProductReservationDelete,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationProductUpdateany,
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationProductTaskUpdate,
        PermissionAttributesEnum.ContextOperationProductReservationUpdate,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationProductCreateany,
        PermissionAttributesEnum.GlobalOperationProductUpdateany,
        PermissionAttributesEnum.GlobalOperationProductDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationProductTaskCreate,
        PermissionAttributesEnum.ContextOperationProductTaskUpdate,
        PermissionAttributesEnum.ContextOperationProductTaskDelete,
        PermissionAttributesEnum.ContextOperationProductReservationCreate,
        PermissionAttributesEnum.ContextOperationProductReservationUpdate,
        PermissionAttributesEnum.ContextOperationProductReservationDelete,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };
}
